import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-bill-matched-items.presenters.BillMatchedItemListPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to load matched items. Please try again.',
  },
})
